import axios from "axios";

export default axios.create({
  baseURL: "http://138.186.62.98:8456/api/",
  headers: {
    "Content-type": "application/json"
  }
});